function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { node, bool, string, oneOf } from 'prop-types';
import classNames from 'classnames';
import './Accordion.scss';
var propTypes = {
  /** Use `AccordionItem` as children */
  children: node.isRequired,

  /** Enables ability to have more than one panel open at a time */
  multiple: bool,

  /** Render the accordion without background color */
  neutral: bool,

  /** Choose the color of the chevron */
  chevronColor: oneOf(['info', 'dark']),

  /** Add your own custom class names to the component */
  className: string,

  /** Choose if you want to render the active content only to the DOM */
  renderActiveContentOnly: bool
};
var defaultProps = {
  multiple: false,
  renderActiveContentOnly: false,
  chevronColor: 'info'
};
/**
 * The accordion allows the user to toggle the visibility of content.
 * */

var Accordion = /*#__PURE__*/function (_Component) {
  _inherits(Accordion, _Component);

  var _super = _createSuper(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, props);
    var state = {
      openItems: {}
    };
    React.Children.toArray(props.children).forEach(function (child) {
      if (child) {
        state.openItems[child.props.id] = !!child.props.expanded;
      }
    });
    _this.state = state;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Accordion, [{
    key: "handleClick",
    value: function handleClick(child) {
      var openItems = this.state.openItems;

      if (this.props.multiple) {
        this.setState({
          openItems: _objectSpread(_objectSpread({}, openItems), {}, _defineProperty({}, child.props.id, !openItems[child.props.id]))
        });
      } else {
        this.setState({
          openItems: _defineProperty({}, child.props.id, !openItems[child.props.id])
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          neutral = _this$props.neutral,
          renderActiveContentOnly = _this$props.renderActiveContentOnly,
          chevronColor = _this$props.chevronColor,
          className = _this$props.className;
      var openItems = this.state.openItems;
      var componentClassNames = classNames('rds-accordion', {
        'rds-accordion--neutral': neutral
      }, className);
      var childrenWithProps = React.Children.map(children, function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          onClick: function onClick(e) {
            return _this2.handleClick(child, e);
          },
          expanded: openItems[child.props.id],
          id: child.props.id,
          renderActiveContentOnly: renderActiveContentOnly,
          chevronColor: chevronColor
        });
      });
      return /*#__PURE__*/React.createElement("div", {
        className: componentClassNames
      }, childrenWithProps);
    }
  }]);

  return Accordion;
}(Component);

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;
export default Accordion;